import http from '../_http_v2';

const pattern = {
  //default
  list: (m) => { return http.post(`console/wsfinder/pattern/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/pattern/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/pattern`, m); },
  update: (m) => { return http.put(`console/wsfinder/pattern`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/pattern/${m.id}`); },

  //test
  test: (m) => { return http.post(`console/wsfinder/pattern/test`, m); },
  testSystem: (m) => { return http.post(`console/wsfinder/pattern/test/system`, m); }
}

export default pattern

export { pattern }